export default __webpack_public_path__ + "static/media/nl-sociais.f22142ef.webp";